"use strict";
/**
 * Craft Room API Types
 *
 * Response types are derived from database record types via SanitizedRecord<T>,
 * which strips all InternalFields (DynamoDB keys, scanning/moderation/security metadata).
 * Request/input types remain standalone interfaces (Requirement 9).
 *
 * Derivation chains:
 * - CraftRoomResponse ← SanitizedRecord<CraftRoomMetadataRecord> + extension
 *     (handlers return identity_id directly — no sanitizeMaterial remapping)
 * - MaterialResponse ← SanitizedRecord<PersonalMaterialRecord> + index signature
 *     (get-user-materials manually picks fields; identity_id preserved)
 * - PublicMaterialApiResponse ← SanitizedRecord<PublicMaterialDisplayRecord> + extension
 *     (formatMaterialResponse picks from display record; adds user_review)
 * - MaterialPageResponse ← SanitizedRecord<PublicMaterialDisplayRecord> + extension
 *     (material-page.ts uses sanitizeResponse then adds patterns/projects/variations)
 */
Object.defineProperty(exports, "__esModule", { value: true });
